// import React from 'react';
import * as React from "react";
import * as ReactDOM from "react-dom";
// import GvpPlayerProps from './gvp-player-props';
// import GvpPlayerProps from './GvpPlayerPropsScroll';
import GvpPlayerState, { Viewtype } from './gvp-player-state';
//import "./gvp-player.css";
import { CTAView, CTAViewData } from "@att-bit/gvp.atoms.cta-view";
import { Player } from "@att-bit/gvp.atoms.player";
// import { CMSReaderAem } from "@att-bit/duc.micro-app.cms-reader-aem";
import { CMSReaderAem } from "@att-bit/gvp.micro-app.cms-reader-aem";
import { CMSService } from "./cms-service";
import { MetaData } from "./meta-data";
import { CMSCommon, cmsLocalData } from "./cms-data";
import { Utils, makeSsrSafe } from "./utils";
import { Spinner } from "@att-bit/duc.fragments.spinner";
//import { CTAViewData } from "@att-bit/gvp.atoms.cta-view/cta-view-props";
import { ReportHelper } from "./report-helper";
import * as CssElementQueries from "css-element-queries";
import { useEffect, useState } from "react";

export type GvpPlayerProps = {
   /**  GVP Data  */
  data: GvpPlayerData;
    /**  GVP Events  */
  events?: GvpPlayerEvents;
    /**  GVP Options  */
  options?: GvpPlayerOptions;
    /**  GVP testId  */
  testId?: string;
  /**  children (text/jsx) to be rendered in component  */
  children?: React.ReactNode;
  /** additional analytics data*/
  additionalAnalyticsData?: any;
  // showOverlay?:Function;
  radius?: boolean;
}

export type GvpPlayerData = {
  video: string;
}

export type GvpPlayerOptions = {
  modal?: boolean;
  cinema?: boolean;
  autoplay?: boolean;
  viewportPause?: boolean;
  autoPlayLoop?: boolean;
  autoPlayPause?: boolean;
  customTheme?: string;
  overlayTextDisplayAtEnd?: boolean;
  tier?: Tier;
  rating?: RatingType;
  customCTAStyle?: string;
  showTime?: boolean;
  showTitle?: boolean;
  videoStyles?: string;
  autoReduceSize?: boolean;
  isScroll?: boolean;
  customCTAObject? : GvpCustomCTAObject;
  playerView?: boolean;
  unconstrained?: boolean;
}

export type GvpCustomCTAObject = {
  svg_size?: string;
  CTAButtonAlignment?: string;
}

export enum RatingType {
  STARS = "stars",
  THUMBS = "Thumbs",
  // THUMBS_INLINE= 'Thumbs_inline',
}

export enum Tier {
  LOCAL = 'LOCAL',
  PRESTAGE = 'PRESTAGE',
  FINALSTAGE = 'FINALSTAGE',
  TST05 = 'TST05',
  PROD = 'PROD',
  ORIGIN = 'ORIGIN',
}

export type GvpPlayerEvents = {
  handleVideoCMSData?(commonInfo: Object): any;
  closeGVPPlayerView?: any;
}

declare global {
  interface Window {
    MediaSource: MediaSource;
    dashjs: any;
    Hls: any;
    chapteredVideoData: any;
  }
}

export const GvpPlayer = (
  props:GvpPlayerProps,
  stateObj:GvpPlayerState
 ) => {
  const [VIDEO, setVideo] = useState<string>(
    '{\
                              "@context"      :     "http://schema.org",\
                              "@type"         :     "VideoObject",\
                              "name"          :     "{{title}}",\
                              "description"   :     "{{description}}",\
                              "thumbnailUrl"  :     "{{thumbnail}}",\
                              "thumbnail"     :     "{{thumbnail}}",\
                              "uploadDate"    :     "{{date}}",\
                              "duration"      :     "{{ptDuration}}",\
                              "contentUrl"    :     "{{seoSource}}.mp4"\
                          }');
  const [state, setState] = useState<GvpPlayerState>(new GvpPlayerState());
  const [gvpRef, setGvpRef] = useState<any>(React.createRef());
  const [playerViewContainerRef, setPlayerViewContainerRef]= useState<any>(React.createRef());
  const [reportingInitialzed, setReportingInitialzed] = useState(false);
  const [reporting, setReporting] = useState<any>();
  const [initialVideoData, setinitialVideoData] = useState<any>();
  const [chapteredVideoData, setChapteredVideoData] = useState<any>([]);
  const [isScroll, setScroll] = useState<boolean>(props.options.isScroll || false);
  const [width, setWidth] = useState<any>(0);
  const [cntRef, setCntRef] = useState<any>(React.createRef());
  const [isPlayerView, setIsPlayerView] = useState<boolean>(false);
  const roundedCornersClassName = props?.radius === false ? ' ' : ' radius-lg';
  const unconstrainedClassName = props?.options?.unconstrained === true ? ' unconstrained': '';
  const [reportingObj, setReportingObj] = useState(null);
  const handleScroll = (e: any) => {
    // console.log("height,Y==>", window.outerHeight, window.scrollY)
    if(isScroll){
      if (getDeviceType() === 'desktop') {
          if (props?.options?.autoReduceSize) {
              // let tempstate = state;
              if (
                  playerViewContainerRef.current &&
                  (window.scrollY + playerViewContainerRef.current.offsetHeight <
                      playerViewContainerRef.current.offsetTop ||
                      window.scrollY > playerViewContainerRef.current.offsetTop)
              ) {
                  // console.log("Scroll Data==>", this.playerViewContainerRef)
                      let tempstate = state;
                      tempstate['isPageScroll'] = true;
                      if(isPlayerView){
                        tempstate['view'] = Viewtype.PlayerView;
                      }
                      setState({...tempstate})
              } else {
                  if (state.isPageScroll) {
                      let tempstate = state;
                      tempstate['isPageScroll'] = false;
                      setState({...tempstate})
                  }
              }
              // setState({...tempstate})
          }
      }
    }
};                       

const reportingFunction = () => {
  let autoPlayLoop = true;
    autoPlayLoop = props.options?.autoPlayLoop === false ? false : true;
    if(!reportingInitialzed && state.cmsReturned){
      switch (state.view) {
        case Viewtype.PlayerView:
          const playerRef = gvpRef && gvpRef.current && gvpRef.current.videoRef && gvpRef.current.videoRef.current && gvpRef.current.videoRef.current.ref && gvpRef.current.videoRef.current.ref.current ? gvpRef.current.videoRef.current.ref.current : {};
          const obj = new ReportHelper(playerRef, state.metaData, false, false, props?.additionalAnalyticsData, autoPlayLoop);
          setReportingObj(obj);
          setReporting({...obj});
        case Viewtype.CTAView:
          if(props.options.autoplay) {
            const CTAViewRefObj = gvpRef && gvpRef.current && gvpRef.current.autoPlayRef ? gvpRef.current.autoPlayRef.current : {};
            const obj = new ReportHelper(CTAViewRefObj, state.metaData, false, props.options && props.options.autoplay, props?.additionalAnalyticsData, autoPlayLoop);
            setReportingObj(obj);
            setReporting({...obj});
          }else{
            return
          }
        //default: setReporting({ ...new ReportHelper(gvpRef.current, state.metaData)});
      }

      setReportingInitialzed(true)
    }

}

const ssrSafeGetVideoFeed = makeSsrSafe(() => {
  console.log("Boolean(getVideoFeed())", Boolean(getVideoFeed()))
  return Boolean(getVideoFeed());
});

const getVideoFeed = () => {
  if(!state.cmsDataLocal){
    const cmsPromise = getCMSDataFromService(props.data.video);
    cmsPromise.then((resp) => {
      const cmdData = resp; 
      console.log("cmdData", cmdData);
      const commonData = cmdData && cmdData.common ? cmdData.common as CMSCommon : null;
      commonData!.id = props.data.video;

      let tempstate = state;
      tempstate['cmsReturned'] = true
      tempstate['metaData'] = commonData ? new MetaData(commonData) : null!
      if (props?.events && props?.events?.handleVideoCMSData) {
        props?.events?.handleVideoCMSData(commonData);        
      }
      setState({...tempstate})
      getChapteredVideoData();

      getRecommendedVideosData(commonData!.recommendedVideoIds || []);
      loadPosterImageByViewPort();

      setinitialVideoData(commonData ? new MetaData(commonData) : null)
      if(!props?.options?.playerView && !props?.options?.autoplay){
        reportingFunction();
      }

    }).catch((videoFeedError: Error) => {  
      console.log("err- videoFeedError", videoFeedError);
      // Below data is for the local to work
      const videoIndex = props.data.video;
      let tempstate = state;
      tempstate['cmsReturned'] = true
      tempstate['metaData'] = new MetaData(cmsLocalData[videoIndex]?.common)
      setState({...tempstate})
      
      getChapteredVideoData();

      // @ts-ignore: TODO
      getRecommendedVideosData(cmsLocalData[videoIndex]?.common.recommendedVideoIds || []);
      loadPosterImageByViewPort();
      // @ts-ignore: TODO
      setinitialVideoData(new MetaData(cmsLocalData[videoIndex]?.common))
      if(!props?.options?.playerView && !props?.options?.autoplay){
        reportingFunction();
      }

      // this.setState({ cmsReturned: true, metaData: null! });
    });
    } else {
          // Below data is for the local to work
        let tempstate = state;
        tempstate['cmsReturned'] = true
        tempstate['metaData'] = new MetaData(cmsLocalData[props.data.video].common)
        setState({...tempstate})

        getChapteredVideoData();

    // @ts-ignore: TODO
      getRecommendedVideosData(cmsLocalData[props.data.video].common.recommendedVideoIds || []);
    loadPosterImageByViewPort();
    // @ts-ignore: TODO
    setinitialVideoData(new MetaData(cmsLocalData[props.data.video].common))
    if(!props?.options?.playerView && !props?.options?.autoplay){
      reportingFunction();
    }

    // this.setState({ cmsReturned: true, metaData: null! });
    }
    CssElementQueries.ElementQueries.init();
  }


  
  const getChapteredVideoData = () => {
    let index = 0;
    let totalTime = state.metaData.seconds;
    let tempstate = state;
    tempstate['duration'] = state.metaData.seconds;
    setState({...tempstate});
    if (
      state.metaData.chapteredVideo &&
      state.metaData.chapteredVideo.length > 0
    ) {
      let cvd = []
      //this.chapteredVideoData.push(this.state.metaData);
      cvd.push(state.metaData);
      setChapteredVideoData([...cvd])
      
      let tempcvd = chapteredVideoData;
      if(tempcvd.length){
        state.metaData.source.forEach((e) => {
          tempcvd[index].sources = '';
          tempcvd[index].sources = e + '.mp4';
        });
      }
      setChapteredVideoData([...tempcvd])
      index++;
      let tempchapterdata = chapteredVideoData;
      state.metaData.chapteredVideo.forEach((chapteredVideo: string) => {
        let videoData = JSON.parse(chapteredVideo);
        videoData = new MetaData(videoData);
        tempchapterdata.push(videoData);
        totalTime = totalTime + videoData.seconds;
        console.log(tempchapterdata)
        if(tempchapterdata.length){
          videoData.sources.forEach((e: string) => {
            tempchapterdata[index].sources = '';
            tempchapterdata[index].sources = e + '.mp4';
          });
        }
        index++;
      });
      setChapteredVideoData([...tempchapterdata]);
      let tempstate = state;
      tempstate['duration'] = totalTime;
      setState({...tempstate});
    }
  }

  const loadPosterImageByViewPort = () => {
    let tempstate = state;
    tempstate['posterImageUrl'] = state?.metaData?.poster;
    setState({ ...tempstate });
  }

  const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return 'tablet';
    }
    if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
            ua,
        )
    ) {
        return 'mobile';
    }
    return 'desktop';
  }



  const getCtaView = (): any => {
    const ctaViewData: CTAViewData = {
      chapteredVideo: chapteredVideoData,
      duration: +state.duration,
      hoverTime: state.metaData.hoverTime,
      hoverToggle:state.metaData.hoverToggle,
      id: props.data.video,
      linkUrl: state.metaData.linkUrl,
      overlayText: state.metaData.overlayText,
      posterImageUrl: state.posterImageUrl,
      seoData: generateSeoData(state.metaData),
      title: state.metaData.title,
      adminDisplay: state.metaData.adminDisplay,
    };
    return (
      <CTAView
        ref={gvpRef}
        data={ctaViewData}
        options={{
          autoPlay: props.options && props.options.autoplay,
          autoPlayLoop: props.options && props.options.autoPlayLoop,
          autoPlaySource: state.metaData.source[0],
          autoReduceSize:
            props.options && props.options.autoReduceSize,
          autoPlayPause: props.options && props.options.autoPlayPause,
          customCTAdisplay: props && props.children,
          customTheme: props.options && props.options.customTheme,
          customCTAStyle: props.options && props.options.customCTAStyle,
          overlayTextDisplayAtEnd:
            props.options && props.options.overlayTextDisplayAtEnd,
          showTime: props.options && props.options.showTime,
          showTitle: props.options && props.options.showTitle,
          startMode: state.metaData.startMode,
          videoStyles: props.options && props.options.videoStyles,
          customCTAObject: props.options && props.options.customCTAObject,
          containerWidth: width,
          roundedCornersClassName: roundedCornersClassName,
          unconstrained: props.options && props.options.unconstrained,
          viewportPause: props.options && props.options.viewportPause
        }}
        events={{ handleCTAClick: handleCtaClick, handleSafariAutoPlay : handleSafariAutoPlay, handlePlayPause: handlePlayPause  }}
      />
    );
  }
  const handleSafariAutoPlay = () => {
    let tempstate = state;
    tempstate['safariAutoPlay'] = true;
    setState({ ...tempstate });
    // props.showOverlay(false);
  }

  const handleCtaClick = () => {
    let tempstate = state;
    tempstate['view'] = Viewtype.PlayerView;
    setState({ ...tempstate });
    setIsPlayerView(true);
    // props.showOverlay(false);
  }

  const getPlayerView = () => {
    const sources: string[] = [];
    let stylesObj: any = {};
        const imgStylesObj: any = {};
        if (props.options && props.options.videoStyles) {
            stylesObj = JSON.parse(props.options.videoStyles);
        }
        // if (props.options && props.options.autoPlay) {
        //     stylesObj[`borderRadius`] = '0px';
        //     stylesObj[`cursor`] = 'default';
        // }
        // if (this.overlayTextData.length > 0) {
        //     stylesObj[`alignItems`] = 'flex-start';
        // }
    if (state.metaData.source) {
      state.metaData.source.forEach((e) => {
        sources.push(Utils.getStreamingSource(e, 'm3u8'));
        sources.push(e + '.mp4');
      });
    }
    const breakpoint = Utils.getBreakPoint();
    let isModal: boolean | undefined = props?.options! && props?.options?.modal!;
    if (
      props.options &&
      typeof props.options.modal === 'undefined' &&
      typeof props.options.cinema === 'undefined'
    ) {
      if (breakpoint === 767) {
        isModal = true;
      }
    }
    const innerHtml = (
      <Player
        ref={gvpRef}
        data={{
          chapteredVideo: chapteredVideoData,
          date: state.metaData.date,
          duration: state.metaData.duration,
          id: props.data.video,
          linkUrl: state.metaData.linkUrl,
          poster: state.metaData.poster,
          printTitle: state.metaData.title,
          recommendedVideosCTAViewData: state.recommendedVideosCTAViewData,
          sources,
          textTracks:
            state.metaData.captions &&
            state.metaData.captions.captions,
          title: state.metaData.title,
        }}
        options={{
          cinema: props.options && props.options.cinema,
          modal: isModal,
          rating: props.options && props.options.rating,
          showCaption: true,
          videoStyles: props.options && props.options.videoStyles,
          safariAutoPlay: state.safariAutoPlay,
          containerWidth: width,
          playerView: props.options && props.options.playerView,
          roundedCornersClassName: roundedCornersClassName,
          unconstrained: props.options && props.options.unconstrained
        }}
        events={{
          close: handlePlayerClose,
          handleVideoCommence: handleVideoCommence, 
          handlePlayPause: handlePlayPause,
          playRecommendedVideoItem: handlePlayerRecommendedVideoItem,
          handleSafariAutoPlay : handleSafariAutoPlay
        }}
      />
    );
    if (props.options && props.options.modal) {
      return ReactDOM.createPortal(innerHtml, document.body);
    } else {
      let GvpPlayer__playerContainer__GT800 = '';
      if(width >= 800) {
        GvpPlayer__playerContainer__GT800 = "GvpPlayer__playerContainer__GT800"
      }
      return (
        <div
          className={`${"GvpPlayer__playerContainer"}` + " "}
        ref={(node) => {
          if (node) {
              Object.keys(stylesObj).forEach((item) => {
                let val = stylesObj[item];
                val = val.replace("!important","")  
                node.style.setProperty(item, val, "important");
              })
          }
      }}
        >
          <div
          ref={playerViewContainerRef}
          onScroll={handleScroll}
          className= {unconstrainedClassName}
        >
          <div
            className={
              state.isPageScroll
                ? "GvpPlayer__scrollSection"
                : '' + unconstrainedClassName
            }
          >
            {innerHtml}
          </div>
        </div>
        </div>
      );
    }
  }
  const handlePlayerClose = () => {
    let tempstate = state;
    if (state.metaData.name !== initialVideoData.name) {
      tempstate['view'] = Viewtype.CTAView;
      tempstate['metaData'] = initialVideoData;
    } else {
      tempstate['view'] = Viewtype.CTAView;
    }
    setState({...tempstate})
    setIsPlayerView(false);
    const playerRef = gvpRef && gvpRef.current && gvpRef.current.videoRef && gvpRef.current.videoRef.current && gvpRef.current.videoRef.current.ref && gvpRef.current.videoRef.current.ref.current ? gvpRef.current.videoRef.current.ref.current : {};
      if(!props.options?.autoplay){
        reporting?.handleCloseEvent(playerRef, true);
      }
      // props.showOverlay(true);
  }

  const handleVideoCommence = () => {
    if(props?.options?.playerView){ 
      reportingFunction();
    }
  }

  const handlePlayPause = (play: boolean) => {
     /* Removing Video_Interact event */
    // if(!props.options?.autoplay){
    //   reporting?.handlePlayPauseEvent(play);
    // }
    
    /* Removing Autoplay Video_Interact event */
    // if(props.options?.autoplay) {
    //   reporting?.handlePlayPauseEvent(play);
    // }

    /* Milestone, when GVP player pauses */
    reporting?.handlePlayPauseEvent(play);

  }

  const handlePlayerRecommendedVideoItem = (mediaId: string) => {
    handlePlayerClose();
    if(!state.cmsDataLocal){
      const cmsPromise = getCMSDataFromService(mediaId);
      cmsPromise
        .then((resp) => {
        const cmdData = resp;
        const commonData = cmdData && cmdData.common ? cmdData.common as CMSCommon : null;
        commonData!.id = props.data.video;
        let tempstate = state;
        tempstate['cmsReturned'] = true;
        tempstate['metaData'] = commonData ? new MetaData(commonData) : null!
        tempstate['view'] = Viewtype.PlayerView;
        setState({...tempstate})
        getRecommendedVideosData(commonData!.recommendedVideoIds || []);
      }).catch((err: Error) => {
        // this.setState({ cmsReturned: true, metaData: new MetaData(cmsLocalData[mediaId].common),
        // view: Viewtype.PlayerView });
        // this.getRecommendedVideosData(cmsLocalData[mediaId].common.recommendedVideoIds);
        let tempstate = state;
        tempstate['cmsReturned'] = true;
        tempstate['metaData'] = new MetaData(null)

        setState({...tempstate})
        console.error('cms route call failed', err);
      });
    } else {
      console.error('cms route call failed');
    }
  }

  const generateSeoData = (data: MetaData): string => {
    let seoData: string = '';
    if (data) {
      const propArr = Utils.splitStringForDoubleCurlies(VIDEO);
      propArr.forEach((e) => {
        // @ts-ignore: TODO RESOLVE LINTING ERROR
        let tempvideo = VIDEO
        tempvideo = tempvideo.replace('{{' + e + '}}', data[e]);
        setVideo(tempvideo);
      });
      seoData =VIDEO;
    }
    return seoData;
  }

  const getCMSDataFromService = (mediaId: string): any => {
    if (mediaId) {
      const tierUrl =
      CMSService.getUrl(props?.options?.tier);
      const url = tierUrl + mediaId + CMSService.feedStr;
      const cmsPromise = CMSReaderAem(url, mediaId);
      return cmsPromise;
    }
  }


  const getRecommendedVideosData = (recommnededVideoIds: any[]): void => {
    let tempstate = state;
    tempstate.recommendedVideosCTAViewData = [];
    setState({...tempstate});
    recommnededVideoIds.forEach((recommnendedVideoId) => {
      const cmsPromise = getCMSDataFromService(recommnendedVideoId);
      cmsPromise
        .then((resp) => {
          // console.log('cms route call successed');
          // const cmdData = CMS.get(cmsLocalData, recommnendedVideoId).content;
          const cmdData = resp;
          const commonData =
            cmdData && cmdData.common ? (cmdData.common as CMSCommon) : null;
          const metaData = commonData ? new MetaData(commonData) : null;
          const ctaViewData = {
            duration: +metaData!.seconds,
            id: recommnendedVideoId,
            posterImageUrl: metaData!.poster,
            recommendedVideo: true,
            seoData: generateSeoData(metaData!),
            title: metaData!.title,
          };
          let tstate = state;
          tstate.recommendedVideosCTAViewData.push(ctaViewData);
          setState({...tstate})

        })
        .catch((err: Error) => {
          //console.error('cms route call failed for recommended videos', err);
        });
    });
  }

  const init_display = () => {
    if (state.cmsReturned && !state.metaData) {
      return (
        <div
          ref={gvpRef}
          style={{ visibility: 'hidden' }}
          data-name="ErrorView"
        >
          Error occured while retriving metadata
        </div>
      );
    } else if (state.cmsReturned) {
      if (state.view === Viewtype.CTAView) {
        return getCtaView();
      } else if (state.view === Viewtype.PlayerView) {
        return getPlayerView();
      }
    } else {
      return props && props.children ? (
        'Loading...'
      ) : (
        <div className={"rel pad-t-sm GvpPlayer__loadercontainer" + roundedCornersClassName} style={{height: '100%'}}>
          <Spinner />
        </div>
      );
    }
  }

  useEffect(() => {
    if(props?.options?.playerView){
      const playerRef = gvpRef && gvpRef.current && gvpRef.current.videoRef && gvpRef.current.videoRef.current && gvpRef.current.videoRef.current.ref && gvpRef.current.videoRef.current.ref.current ? gvpRef.current.videoRef.current.ref.current : {};
      if(!props.options?.autoplay){
        reporting?.handleCloseEvent(playerRef, true);
      }
    }
  }, [props?.events?.closeGVPPlayerView])

  useEffect(() => {
    let stylesObj: any = {};
    if (props.options && props.options.videoStyles) {
      stylesObj = JSON.parse(props.options.videoStyles);
    }
    let ctaContainerWidth;
    if(stylesObj?.width){
      //stylesObj = parseInt(stylesObj.width, 10);
      stylesObj = String(stylesObj.width).replace("px","")
      ctaContainerWidth = stylesObj;
      setWidth(stylesObj)
    }
    else {
      ctaContainerWidth = cntRef.current.clientWidth
      setWidth(cntRef.current.clientWidth)
    }
    console.log("ctaContainerWidth", ctaContainerWidth); 
    if(chapteredVideoData.length === 0){
      getVideoFeed()
    }

  }, [ props.data.video])

  // useEffect(() => {
  //   if(!props?.options?.playerView){
  //     reportingFunction();
  //   }
  // }, [(state.view === Viewtype.PlayerView)])

  useEffect(() => {
    if(!props?.options?.playerView && state.view === Viewtype.PlayerView){
      reportingFunction();
    }
  }, [state.view])

  useEffect(() => {
    if(props.options.playerView){
      let tempstate = state;
      tempstate['view'] = Viewtype.PlayerView;
      reportingFunction();
      setState({ ...tempstate });
    }
  }, [ state.cmsReturned])

  useEffect(() => {
    if(isScroll){
      document.addEventListener<'scroll'>('scroll', handleScroll);
    }
    return () => {
      if(isScroll){
        document.removeEventListener('scroll', handleScroll);
      }
    }
  }, [state.isPageScroll, isPlayerView])

  useEffect(() => {
    if(props.options.autoplay && state.cmsReturned && state.view === Viewtype.CTAView){
      reportingFunction();
    }
  }, [state.cmsReturned])
  
  return (
    <>
{/*
      // @ts-ignore */}
    <style jsx global>{`
    .GvpPlayer__loadercontainer {
      background: #000;
      min-height: 300px;
      position: relative;
      width: 100%; }
    
    .GvpPlayer__loader,
    .GvpPlayer__loader:after {
      border-radius: 50%;
      width: 10em;
      height: 10em; }
    
    .GvpPlayer__loader {
      margin: auto;
      top: 120px;
      font-size: 5px;
      position: relative;
      border-top: 1.1em solid rgba(255, 255, 255, 0.2);
      border-right: 1.1em solid rgba(255, 255, 255, 0.2);
      border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
      border-left: 1.1em solid #ffffff;
      -webkit-transform: translateZ(0);
      -ms-transform: translateZ(0);
      transform: translateZ(0);
      -webkit-animation: GvpPlayer__spinner 1.1s infinite linear;
      animation: GvpPlayer__spinner 1.1s infinite linear; }
    
    @-webkit-keyframes GvpPlayer__spinner {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg); }
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg); } }
    
    @keyframes GvpPlayer__spinner {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg); }
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg); } }
    
    .GvpPlayer__playerContainer {
      width: 100%;
      height: 100%; }
    .GvpPlayer__playerContainer button:focus {
        outline: 3px dotted;
        outline-color: #fff; 
      }
    
    .GvpPlayer__scrollSection {
      width: 30%;
      position: fixed;
      right: 10px;
      bottom: 10px;
      z-index: 100; }
    
    .GvpPlayer__playerContainer__GT800 {
      min-height: 500px;
    }

    .unconstrained {
      height: 100% !important;
      width: 100% !important;
    }

    .react-playground_previewBox__1j7I- .gvpBitCloud {
      width: 350px !important;
    }

    .react-playground_previewBox__1bgmy .gvpBitCloud {
      width: 350px !important;
    }
    
    .composition-card_compositionContainer__2fwln .gvpBitCloud {
      width: 350px !important;
    }

    .composition-card_compositionContainer__3g1C8 .gvpBitCloud {
      width: 350px !important;
    }

    .composition-card_compositionContainer__1Y9im .gvpBitCloud {
      width: 350px !important;
    }

    `}</style>
    <div className={"gvpBitCloud" + unconstrainedClassName } data-testid={props.testId} style={{width: '100%'}} >
      <div ref={cntRef} className={"gvpContainer" + roundedCornersClassName + unconstrainedClassName} style={{width: '100%'}} >
      { 
        init_display()
      }
      </div>
    </div>
    </>
  )
}
export default GvpPlayer;